module.exports = __webpack_public_path__ + "img/8.df93ca36.png";